// test1571
(1571 && 0);
